import { creditHealthUrl, statementsUrl, statementsEnrollmentUrl, accountActivityUrl, autoRegisterUrl, paymentQueryUrl, accountSummaryV2Url, creditAccountsUrl, autopayStatusUrl, autopayEligibilityUrl, payoffQuoteUrl, paymentMethodsUrl, settlementEligibilityUrl, accountFeaturesUrl, paymentEnterpriseEligibilityUrl, profileUrl, merchantInfoUrl, promotionsUrl } from "./endpoints.js";
const creditHealthCacheKey = ({
  accountId,
  accountIdType,
  lang
}) => [creditHealthUrl, { accountId, accountIdType, lang }];
const statementsCacheKey = ({
  accountId,
  accountIdType
}) => [statementsUrl, { accountId, accountIdType }];
const statementsEnrollmentCacheKey = ({
  accountId,
  accountIdType
}) => [statementsEnrollmentUrl, { accountId, accountIdType }];
const accountActivityCacheKey = ({
  accountId,
  accountIdType
}) => [accountActivityUrl, { accountId, accountIdType }];
const autoRegisterCacheKey = (props) => [autoRegisterUrl, props];
const paymentQueryCacheKey = ({
  accountId,
  accountIdType,
  page,
  size
}) => [paymentQueryUrl, { accountId, accountIdType, page, size }];
const accountSummaryV2CacheKey = ({
  accountId,
  accountIdType
}) => [accountSummaryV2Url, { accountId, accountIdType }];
const creditAccountsCacheKey = () => [creditAccountsUrl];
const autopayStatusCacheKey = ({
  accountId,
  accountIdType
}) => [autopayStatusUrl, { accountId, accountIdType }];
const autopayEligibilityCacheKey = ({
  accountId,
  accountIdType,
  requestor
}) => [autopayEligibilityUrl, { accountId, accountIdType, requestor }];
const payoffQuoteCacheKey = ({
  accountId,
  accountIdType
}) => [payoffQuoteUrl, { accountId, accountIdType }];
const paymentMethodsCacheKey = ({
  accountId,
  accountIdType
}) => [paymentMethodsUrl, { accountId, accountIdType }];
const settlementEligibilityCacheKey = ({
  accountId,
  accountIdType
}) => [settlementEligibilityUrl, { accountId, accountIdType }];
const accountFeaturesCacheKey = ({
  accountId,
  accountIdType
}) => [accountFeaturesUrl, { accountId, accountIdType }];
const paymentEnterpriseEligibilityCacheKey = ({
  accountId,
  accountIdType
}) => [paymentEnterpriseEligibilityUrl, { accountId, accountIdType }];
const alternatePaymentMethodsCacheKey = ({
  accountId,
  accountIdType
}) => ["alternatePaymentMethods", { accountId, accountIdType }];
const profileDetailsCacheKey = ({
  accountId,
  accountIdType
}) => [`${profileUrl}-details`, { accountId, accountIdType }];
const profileScopeCacheKey = ({
  accountId,
  accountIdType
}) => [`${profileUrl}-scope`, { accountId, accountIdType }];
const merchantInfoCacheKey = ({
  merchantId
}) => [merchantInfoUrl, merchantId];
const promotionsCacheKey = ({
  accountId,
  accountIdType
}) => [promotionsUrl, { accountId, accountIdType }];
const cancelPaymentCacheKey = ({
  accountId,
  accountIdType
}) => [paymentQueryUrl, { accountId, accountIdType }];
export { accountActivityCacheKey, accountFeaturesCacheKey, accountSummaryV2CacheKey, alternatePaymentMethodsCacheKey, autoRegisterCacheKey, autopayEligibilityCacheKey, autopayStatusCacheKey, cancelPaymentCacheKey, creditAccountsCacheKey, creditHealthCacheKey, merchantInfoCacheKey, paymentEnterpriseEligibilityCacheKey, paymentMethodsCacheKey, paymentQueryCacheKey, payoffQuoteCacheKey, profileDetailsCacheKey, profileScopeCacheKey, promotionsCacheKey, settlementEligibilityCacheKey, statementsCacheKey, statementsEnrollmentCacheKey };
//# sourceMappingURL=cacheKeys.js.map
